/**
 * Ebooks and Bibles are read in Lifeway Reader, not here — this app never renders
 * an EPUB. See docs/docs/domain/ereading.md.
 *
 * `id` is the content GUID `libraryV2` gives us on `Ebook.id`. The base URL is
 * per-environment (see `VITE_READER_URL`), so it's an argument, not a constant.
 */
import { ENV } from "~/ENV"

export const readerUrl = (id: string, baseUrl: string = ENV.READER_URL): string =>
  `${baseUrl.replace(/\/+$/, "")}/reader/${encodeURIComponent(id)}`
